import gql from 'graphql-tag'
import api from './apiClient'

export default {
  readAllByEmisor: emisor =>
    api
      .send({
        query: gql`
          query READ_ALL($emisor: ID!) {
            Merma {
              readAllByEmisor(emisor: $emisor) {
                _id
                tipo
                causa
                cuentaContable
              }
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Merma.readAllByEmisor),

  create: input =>
    api
      .send({
        query: gql`
          mutation CREATE($input: MermaInput!) {
            Merma {
              create(input: $input) {
                _id
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Merma.create),

  mermaSalida: (input, accounting) =>
    api
      .send({
        query: gql`
          mutation SALIDA($input: ControlMermaInput!, $accounting: Boolean) {
            Merma {
              mermaSalida(input: $input, accounting: $accounting)
            }
          }
        `,
        variables: {
          input,
          accounting
        }
      })
      .then(result => result.data.data.Merma.mermaSalida),

  delete: input =>
    api
      .send({
        query: gql`
          mutation delete($input: [ID!]!) {
            Merma {
              delete(input: $input) {
                _id
                state
                message
              }
            }
          }
        `,
        variables: { input }
      })
      .then(result => result.data.data.Merma.delete),

  readAllControlMerma: (cursor, limit = 10, emisor, filter = null, accounting = false) =>
    api
      .send({
        query: gql`
          query readAllControlMerma($cursor: String, $limit: Int, $emisor: ID!, $filter: FilterControlMerma, $accounting: Boolean) {
            Merma {
              readAllControlMerma(cursor: $cursor, limit: $limit, emisor: $emisor, filter: $filter, accounting: $accounting) {
                feed {
                  _id
                  #emisor
                  #item
                  registro {
                    _id
                    tipo
                    causa
                    cuentaContable {
                      _id
                      name
                      code
                    }
                  }
                  cantidad
                  costoUnitario
                  observacion
                  #user
                  fecha
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          cursor,
          limit,
          emisor,
          filter,
          accounting
        }
      })
      .then(result => result.data.data.Merma.readAllControlMerma),

  readAllControlMermaByDateRange: (emisor, inicio, final, filter = null, accounting = false) =>
    api
      .send({
        query: gql`
          query readAllControlMermaByDateRange($emisor: ID!, $inicio: Date, $final: Date, $filter: FilterControlMerma, $accounting: Boolean) {
            Merma {
              readAllControlMermaByDateRange(emisor: $emisor, inicio: $inicio, final: $final, filter: $filter, accounting: $accounting) {
                feed {
                  _id
                  #emisor
                  item {
                    _id
                    nombre
                  }
                  registro {
                    # _id
                    tipo
                    causa
                  }
                  cantidad
                  costoUnitario
                  observacion
                  #user
                  fecha
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          inicio,
          final,
          filter,
          accounting
        }
      })
      .then(result => result.data.data.Merma.readAllControlMermaByDateRange)
}
